<template>
<div class="container">
  <div id="div_banner" class="banner1">
    <img src="../../assets/xinwen.png" alt="新闻中心Banner">
      <div>
        <p>新闻中心</p>
        <span>News</span>
      </div>
<!--    <img v-if="imgUrl"  :src="baseUrl+imgUrl"  alt="新闻中心" height="190">-->
  </div>
  <div class="tr1">
    <div id="div_newsNav" class="btn">
      <a @click="getCompanyTrendsDate" class="a1" id="G">公司新闻</a>
      <a @click="getIndustryTrendsDate" class="a1" id="H">行业动态</a></div>
    <div class="tr1_main">
      <div>
        <div id="div_newsFirst" class="top" v-if="firstNews!==''">
          <div class="box clearfix" >
            <div class="pic_box">
              <img :src="baseUrl + firstNews.fimgUrl">
            </div>
            <div class="text">
              <h2>{{firstNews.freleaseDate}}</h2>
              <h1>{{firstNews.ftitle}}</h1>
              <div style="display: -webkit-box;-webkit-box-orient: vertical; -webkit-line-clamp: 3;overflow: hidden;">{{firstNews.fabstract}}</div>
              <router-link  :to="{path: '/trendDetail',query:{id:firstNews.fnewsId}}" class="more">查看详情<span></span></router-link>
            </div>
          </div>
        </div>
        <div class="bom">
          <div id="div_news" class="box" v-if="TrendsDate">
            <div class="tr1_list clearfix" ref="tr1_list" v-for="item in TrendsDate">
              <div class="pic_box">
                <img :src="baseUrl  + item.fimgUrl" alt="义乌市委常委、副市长王新峰一行莅临公司调研指导">
              </div>
              <div class="text">
                <h2>{{item.ftitle}}</h2>
                <div class="ti">{{item.fabstract}}</div>
                <div class="bom1">
                  <span>{{item.freleaseDate}}</span>
                  <router-link  :to="{path: '/trendDetail',query:{id:item.fnewsId}}" class="more">查看详情</router-link>
                </div>
              </div>
            </div>
            <div class="newspg" id="murlpages">
              <div class="page1" v-if="total>2">
                <el-pagination
                  @current-change="currentChangHandel"
                  :current-page="currentPage"
                  :small="true"
                  background
                  :page-size="2"
                  layout="prev, pager, next"
                  :total="total">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  import $ from 'jquery'
  import axios from '../../../static/js/commonAxios'
  export default {
    name: "trends",
    data(){
      return{
        TrendsDate:[],
        firstNews:'',
        total:0,
        currentPage:1,
        baseUrl:'',
        type:'G',
        imgUrl:''
      }
    },
    mounted(){
      this.baseUrl = process.env.API_ROOT;
      this.getbar()
      this.getTrendsDate()
      this.getPageDate()
    },
    methods:{
      getbar(){
        axios.get('/api/bar').then((res) => {
          if(res.data.success){
            let item=res.data.items
            item.forEach(arr=>{
              if(arr.fbar==='新闻中心'){
                this.imgUrl =  arr.fbarUrl
              }
            })
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },
      getCompanyTrendsDate(){
        this.type = 'G'
        this.getTrendsDate()
        this.getPageDate()
      },
      getIndustryTrendsDate(){
        this.type = 'H'
        this.getTrendsDate()
        this.getPageDate()
      },
      getTrendsDate(){
        axios.get(`/api/firstNews?fnewsType=${this.type}`).then((res) => {
          if(res.data.success){
            console.log('请求结果');
            if( res.data.items){
              this.firstNews = res.data.items[0]
            }else{
              this.firstNews = ''
            }
            console.log(this.firstNews);
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },
      getPageDate(){
        axios.get(`/api/newsPage?page=${this.currentPage}&limit=2&fnewsType=${this.type}`).then((res) => {
          if(res.data.success){
            console.log('分页请求结果');
            console.log(res);
            this.TrendsDate = res.data.items
            this.total = res.data.total
            this.$nextTick(()=>{
              $('.tr1 .btn a').removeClass('active')
              $("#"+this.type).addClass('active')
              $('.page1 span ').removeClass('current')
              $("#"+this.currentPage).addClass('current')
              $(".tr1_list").hover(function(){
                $(this).stop(true,true).animate({left:"-20px"});
              },function(){
                $(this).stop(true,true).animate({left:"0px"});
              })
            })
            console.log('下列显示');
            console.log(this.TrendsDate);
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },
      currentChangHandel(val){
        this.currentPage = val
        this.getPageDate()
      }
    }
  }
</script>

<style scoped>

  .tr1{
    width: 100%;
    padding-top: 80px;
  }
  .tr1 .btn{
    text-align: center;
    border-bottom: 1px solid #ccc;

  }
  .tr1 .btn a{
    cursor: pointer;
    font-size: 18px;
    color: #666;
    padding-bottom: 20px;
    margin-right: 80px;
    display: inline-block;
    padding-left: 30px;
    text-decoration: none;
    color: #666;
  }
  .tr1 .btn a:hover{
    color: #333;
  }
  .tr1 .btn .active{
    border-bottom: 1px solid #8ec31f;
    color: #333;
  }

  .tr1 .btn .a1{
    background: url(../../assets/43.png) no-repeat left 4px;
  }

  .tr1 .tr1_main{
    width: 100%;
    margin-top: 30px;
  }
  .tr1 .tr1_main .top{
    width: 100%;
    padding-bottom: 40px;
  }
  .tr1 .tr1_main .top .pic_box{
    width: 600px;
    height: 337px;
    overflow: hidden;
    float: left;
  }
  .tr1 .tr1_main .top .pic_box img{
    display: block;
    height: 100%;
    width: auto;
  }
  .tr1 .tr1_main .top .text{
    width: 540px;
    height: 337px;
    float: right;
    position: relative;
  }
  .tr1 .tr1_main .top .text h2{
    color: #333;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .tr1 .tr1_main .top .text h1{
    font-size: 18px;
    font-weight: bold;
    color: #333;
    padding-bottom: 20px;
    background: url(../../assets/24.jpg) no-repeat left bottom;
  }
  .tr1 .tr1_main .top .text div{
    margin-top: 20px;
    font-size: 14px;
    color: #666;
    line-height: 30px;
  }
  .tr1 .tr1_main .top .text a{
    display: block;
    width: 538px;
    height: 58px;
    border: 1px solid #8ec31f;
    line-height: 58px;
    text-align: center;
    color: #8ec31f;
    position: absolute;
    text-decoration: none;
    bottom: 0;
    background: url(../../assets/45.png) no-repeat 40% center;
  }
  .tr1 .tr1_main .top .text a span{
    width: 100%;
    height: 100%;
    background: #8ec31f;
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
    display: block;
    transform:scale(1,0);
    -ms-transform:scale(1,0); 	/* IE 9 */
    -moz-transform:scale(1,0); 	/* Firefox */
    -webkit-transform:scale(1,0); /* Safari 和 Chrome */
    -o-transform:scale(1,0); 	/* Opera */
    transition: all .8s;
    -moz-transition: all .8s; /* Firefox 4 */
    -webkit-transition: all .8s; /* Safari 和 Chrome */
    -o-transition: all .8s; /* Opera */
  }
  .tr1 .tr1_main .top .text a:hover{
    color: #fff;
  }
  .tr1 .tr1_main .top .text a:hover span{
    transform:scale(1,1);
    -ms-transform:scale(1,1); 	/* IE 9 */
    -moz-transform:scale(1,1); 	/* Firefox */
    -webkit-transform:scale(1,1); /* Safari 和 Chrome */
    -o-transform:scale(1,1); 	/* Opera */
  }
  .tr1 .tr1_main .bom{
    width: 100%;
    padding-top: 40px;
    background: #fff;
    padding-bottom: 80px;
  }
  .tr1 .tr1_main .bom .tr1_list{
    width: 100%;
    margin-bottom: 20px;
    position: relative;
  }
  .tr1 .tr1_main .bom .tr1_list .pic_box{
    width: 380px;
    height: 210px;
    overflow: hidden;
    float: left;

  }
  .tr1 .tr1_main .bom .tr1_list .pic_box img{
    display: block;
    width: 100%;
  }
  .tr1 .tr1_main .bom .tr1_list .text{
    width: 780px;
    padding: 10px;
    padding-bottom: 30px;
    float: right;
    border-bottom: 1px solid #000;
  }
  .tr1 .tr1_main .bom .tr1_list .text h2{
    font-size: 18px;
    color: #333;
    font-weight: bold;
    padding-top: 20px;
    padding-bottom: 20px;
    background: url(../../assets/24.jpg) no-repeat left bottom;
    /*margin-bottom: 20px;*/
  }
  .tr1 .tr1_main .bom .tr1_list .text .ti{
    line-height: 30px;
    color: #666;
    font-size: 14px;
  }
  .tr1 .tr1_main .bom .tr1_list .text .bom1{
    line-height: 40px;
    margin-top: 20px;
  }
  .tr1 .tr1_main .bom .tr1_list .text .bom1 span{
    font-size: 14px;
    color: #999;
    padding-left: 25px;
    background: url(../../assets/46.png) no-repeat left center;
  }
  .tr1 .tr1_main .bom .tr1_list .text .bom1 a{
    display: block;
    float: right;
    height: 40px;
    width: 100px;
    text-align: center;
    padding-left: 20px;
    text-decoration: none;
    background: url(../../assets/45.png) no-repeat 10px center #8ec31f;
    color: #fff;
  }
  .tr1 .tr1_main .bom .tr1_list .text .bom1 a:hover{
    background: url(../../assets/45.png) no-repeat 10px center #36395a;
  }
  /****************************** 分页 ******************************/
  .page1{clear:both; text-align:center;font-size:12px; height:24px; line-height:24px;}
  .page1 span a{border:1px solid #8ec31f;color:#8ec31f;padding:2px 6px;line-height:15px;height:15px;text-decoration:none;background:#fff;}
  .page1 span a:hover{border:1px solid #999;color:#999;}
  .page1 span{margin:2px;}
  .page1 span.current a{border:1px solid #8ec31f;background:#8ec31f;color:#fff;}
  .page1 span a.disabled{border:1px solid #ccc;color:#ccc;cursor:default;}

</style>



// WEBPACK FOOTER //
// src/components/trends/trends.vue